module.exports = __webpack_public_path__ + "99b967b4e9aff8ed3394c8afd50c30a3.svg";